// Stimulus controller: auto-computes CBM (m³) from L×W×H dimensions (cm) on
// the admin product variant form, while the CBM field itself stays editable —
// dimensions only pre-fill/refresh it, they never lock it.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["length", "width", "height", "cbm"]

  recalc() {
    const l = parseFloat(this.lengthTarget.value)
    const w = parseFloat(this.widthTarget.value)
    const h = parseFloat(this.heightTarget.value)
    if (l > 0 && w > 0 && h > 0) {
      this.cbmTarget.value = ((l * w * h) / 1000000).toFixed(6)
    }
  }
}
